/**
 * wpMedia — WordPress Media Library URL helper
 *
 * Resolves a media-library path (e.g. "2026/06/my-image.png") to a full
 * absolute URL using the uploads base URL injected by WordPress via
 * window.aquifyConfig.  Falls back to the live aquify.org uploads URL so
 * the React dev server still renders images correctly even without WP.
 *
 * @param {string} path  Relative path under wp-content/uploads/
 *                       e.g. "2026/06/aquify-dsis-logo.png"
 * @returns {string}     Absolute URL to the file in the Media Library
 */
export function wpMedia(path) {
  const uploadsBaseUrl =
    window.aquifyConfig?.uploadsUrl || "https://aquify.org/wp-content/uploads";

  return `${uploadsBaseUrl.replace(/\/$/, "")}/${path.replace(/^\/+/, "")}`;
}
